import { render, staticRenderFns } from "./summary-list.vue?vue&type=template&id=4805bed5&scoped=true&"
import script from "./summary-list.vue?vue&type=script&lang=js&"
export * from "./summary-list.vue?vue&type=script&lang=js&"
import style0 from "./summary-list.vue?vue&type=style&index=0&id=4805bed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4805bed5",
  null
  
)

export default component.exports